import type { CaseDetail } from '@/mocks/portfolio';

const jwwTisiCase: CaseDetail = {
  id: 'jww-tisi',
  project: 'JWW TISI Exhibition',
  client: 'TISI',
  year: '2024',
  category: 'B2B Event / Spatial / Token',
  role: 'Exhibition Design / Spatial / Communication',
  issue: 'B2B展示会において、事業の技術力が伝わる一方、ブランドとしての魅力や体験が不足していた。',
  challenge: '専門的なWeb3・DX事業を、来場者が興味を持ち、体感できる展示体験にすること。',
  insight: 'B2Bでも「技術の正しさ」より「触れる・感じる・体験の面白さ」が、来場者の記憶に残る。Japan Web3 Week / DX総合EXPO 2024で差別化が必要。',
  strategy: '事業価値を体験として構成し、インタラクティブな展示ブースで来場者が実際に触れて感じられる展示を設計。',
  experience: '展示空間、体験コンテンツ、トークン技術のデモ、コミュニケーションを通じて、ブランド体験を構築。',
  output: 'Exhibition Booth Design / Spatial / Interactive Demo / Experience / Communication',
  impact: '展示会でのブランド体験を強化し、来場者との関係構築とリード獲得を実現。',
  images: [
    {
      src: '/assets/migrated/4e6eca51891b8b03504b.webp',
      caption: 'TISブース実写 — Web3技術を活用した「魅せる」顧客体験・スタッフ対応',
    },
    {
      src: '/assets/migrated/79b69c5d34b3bbea7db3.webp',
      caption: 'HANASAKIYAMA DOBUROKU / チケット招待券 & NFT証明 — Japan Web3 Week Limited Exchange Ticket',
    },
    {
      src: '/assets/migrated/1e7e3efd3646ad76d888.webp',
      caption: 'HANASAKIYAMA DOBUROKU. 2024 / DIGITAL AMBASSADOR — スマホNFT体験（単体）',
    },
    {
      src: '/assets/migrated/23ad9e5bd518f8a7ac59.webp',
      caption: 'DX総合EXPO TISブース企画 / Japan Web3 Week — 全体イベント造作設計案 PLAN/立面図',
    },
    {
      src: '/assets/migrated/0ba4fa49668d278d29fb.webp',
      caption: 'HANASAKIYAMA DOBUROKU / FAN証明 — Digital Ambassador カード＋スマホモックアップ',
    },
    {
      src: '/assets/migrated/f91bcdd218ef07af7c1a.webp',
      caption: 'TISブース実写 — 会場通路からの眺め・スタッフと来場者',
    },
    {
      src: '/assets/migrated/57526683262aa9c72a1c.webp',
      caption: 'DX総合EXPO TISブース — CGパース・3D外観レンダリング（東京ビッグサイト）',
    },
    {
      src: '/assets/migrated/a09c274fe9e09a52b9da.webp',
      caption: 'DX総合EXPO TISブース実写 — 内観・トーテムディスプレイ・花咲山どぶろく展示',
    },
    {
      src: '/assets/migrated/missing-transparent.gif',
      caption: 'HANASAKIYAMA 展示台用 DESIGN 入稿データ — 完成イメージ・CUTイメージ・ブースCGパース',
    },
    {
      src: '/assets/migrated/d9a2c881811fd632f912.webp',
      caption: 'DX総合EXPO TISブース実写 — 東8ホール ワイドショット・全体像',
    },
    {
      src: '/assets/migrated/e1a9de51aed267e439e6.webp',
      caption: 'HANASAKIYAMA DOBUROKU / Japan Web3 Week LIMITED EXCHANGE TICKET — スマホ単体表示',
    },
    {
      src: '/assets/migrated/07332b1eb6f50e34716f.webp',
      caption: 'DX総合EXPO TISブース実写 — ワイドショット・来場者エンゲージメント',
    },
    {
      src: '/assets/migrated/6755f0a5ef71e91da42b.webp',
      caption: 'RWAトークン グラフィック盤面 — Made in Japan の魅力・ブースCGパース composite',
    },
    {
      src: '/assets/migrated/missing-transparent.gif',
      caption: 'DX総合EXPO TISブース企画 — PLAN/立面図/部分詳細図・全体イベント造作設計案',
    },
    {
      src: '/assets/migrated/6617f408799b70b0a6a5.webp',
      caption: 'DX総合EXPO TISブース — CGパース 俯瞰図・全体イベント造作設計案',
    },
    {
      src: '/assets/migrated/172ac3d5750259cf8757.webp',
      caption: 'TISブース実写 — ディスプレイ・来場者エンゲージメント・スタッフ対応',
    },
    {
      src: '/assets/migrated/edf9a20c273a7150dfae.webp',
      caption: 'TISブース実写 — 全体像・来場者エンゲージメント',
    },
    {
      src: '/assets/migrated/7b2030b382f140720c14.webp',
      caption: 'TISブース実写 — 内観・トーテムディスプレイ・花咲山どぶろく展示',
    },
  ],
};

export default jwwTisiCase;